/**
 * Relatórios do módulo — telas `2g` (dashboard publicado) e `2h` (resultado
 * acumulado, que o wireframe chama de "o coração da ferramenta").
 */
import { z } from 'zod'

import { dinheiro } from './comum'

/**
 * As 5 métricas de valor da `2g`, somadas SOBRE O CONJUNTO FILTRADO.
 *
 * 🔒 Somadas no SERVIDOR, e nunca aqui. Somar no navegador somaria só a página
 * carregada e mostraria o total DA PÁGINA achando que é o total geral — um
 * número errado com cara de certo. E o conjunto somado é exatamente o mesmo da
 * tabela abaixo dos cards, incluindo o gate do BR-01.
 */
export const resumoDoRelatorioSchema = z.object({
  contagem: z.number(),
  custoMensalAtual: dinheiro,
  custoMensalPotencial: dinheiro,
  economiaMensalPotencial: dinheiro,
  custoMensalAposImplementacao: dinheiro,
  economiaMensalAposImplementacao: dinheiro,
  moeda: z.string(),
})

export type ResumoDoRelatorio = z.infer<typeof resumoDoRelatorioSchema>

export const pontoDaSerieSchema = z.object({
  /** `YYYY-MM`. */
  mes: z.string(),
  /** Serviço, conta ou `"total"`, conforme o `agruparPor`. */
  grupo: z.string(),
  economiaNoMes: dinheiro,
  /**
   * 🔴 `null` para a série CÍCLICA, e isso é uma afirmação deliberada de
   * ignorância. Zero diria "não acumulou nada"; `null` diz "ainda não sabemos
   * como acumular isto". A tela renderiza a diferença.
   */
  acumulado: dinheiro.nullable(),
})

export type PontoDaSerie = z.infer<typeof pontoDaSerieSchema>

export const avisoSchema = z.object({
  codigo: z.string(),
  message: z.string(),
})

export type Aviso = z.infer<typeof avisoSchema>

/**
 * 🔴 **BR-27 — duas séries separadas, de propósito.**
 *
 * Saving Plans e Reserved Instances "não acumulam mês a mês como as outras"
 * (Eduardo), e a regra exata segue aberta com a iOX — ele mesmo disse que "a
 * regra de back-end é que eu preciso quebrar a cabeça um bocado". As opções
 * óbvias dão TOTAIS DIFERENTES, e esta é a tela que o wireframe chama de "o
 * coração da ferramenta": um número errado aqui é pior que um número ausente.
 *
 * Então o backend devolve `acumulativa` e `ciclica` separadas, mais um
 * `avisos[]` que a tela renderiza como callout. É como o servidor diz "não
 * inventei" de um jeito que CHEGA ao usuário, em vez de morrer num comentário.
 */
export const serieDeEconomiaSchema = z.object({
  moeda: z.string(),
  series: z.object({
    acumulativa: z.array(pontoDaSerieSchema),
    ciclica: z.array(pontoDaSerieSchema),
  }),
  avisos: z.array(avisoSchema),
  periodo: z.object({ de: z.string(), ate: z.string() }),
  agruparPor: z.enum(['servico', 'conta', 'nenhum']),
})

export type SerieDeEconomia = z.infer<typeof serieDeEconomiaSchema>
